export default {
  MuiIconButton: {
    root: {
      padding: 0,
    },
  },
};
